<template>
  <div class="header">
    <el-menu
      mode="horizontal"
      background-color="#212121"
      text-color="#FF5722"
      style="border:none;">
      <el-menu-item style="font-size:20px; font-weight: bold;">ACL Paper Search Engine</el-menu-item>
    </el-menu>
  	
    <!-- h1>ACL Paper Search Engine</h1 -->
    <!-- <h3>Yiran Tao, Kechen Lu, Xinran Wang, Weilin Zhang</h3> -->
  </div>
</template>

<script>
export default {
  name: 'Header',
}
</script>

<style scoped>
.header {
    text-align: center;
    border: none;
}
</style>
